import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 8rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 757px;
  justify-content: flex-end;
`;

export const ButtonCreateEstablishment = styled.button`
  width: 265px;
  height: 45px;
  border: 1px solid #2493eb;
  color: #2493eb;
  background: #f9f9fb 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
  margin-top: 30px;
`;
